/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rental_Loading_CalendarInputs */

const en_rental_loading_calendar = /** @type {(inputs: Rental_Loading_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading availability...`)
};

const es_rental_loading_calendar = /** @type {(inputs: Rental_Loading_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando disponibilidad...`)
};

const fr_rental_loading_calendar = /** @type {(inputs: Rental_Loading_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement des disponibilités...`)
};

const de_rental_loading_calendar = /** @type {(inputs: Rental_Loading_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verfügbarkeit wird geladen...`)
};

const id_rental_loading_calendar = /** @type {(inputs: Rental_Loading_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memuat ketersediaan...`)
};

/** @type {(inputs: Rental_Loading_CalendarInputs) => LocalizedString} */
const ja_rental_loading_calendar = en_rental_loading_calendar;

/** @type {(inputs: Rental_Loading_CalendarInputs) => LocalizedString} */
const zh_rental_loading_calendar = en_rental_loading_calendar;

/** @type {(inputs: Rental_Loading_CalendarInputs) => LocalizedString} */
const ar_rental_loading_calendar = en_rental_loading_calendar;

/** @type {(inputs: Rental_Loading_CalendarInputs) => LocalizedString} */
const it_rental_loading_calendar = en_rental_loading_calendar;

/** @type {(inputs: Rental_Loading_CalendarInputs) => LocalizedString} */
const ru_rental_loading_calendar = en_rental_loading_calendar;

/** @type {(inputs: Rental_Loading_CalendarInputs) => LocalizedString} */
const pt_rental_loading_calendar = en_rental_loading_calendar;

/** @type {(inputs: Rental_Loading_CalendarInputs) => LocalizedString} */
const ko_rental_loading_calendar = en_rental_loading_calendar;

/**
* | output |
* | --- |
* | "Loading availability..." |
*
* @param {Rental_Loading_CalendarInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const rental_loading_calendar = /** @type {((inputs?: Rental_Loading_CalendarInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rental_Loading_CalendarInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rental_loading_calendar(inputs)
	if (locale === "es") return es_rental_loading_calendar(inputs)
	if (locale === "fr") return fr_rental_loading_calendar(inputs)
	if (locale === "de") return de_rental_loading_calendar(inputs)
	if (locale === "ja") return ja_rental_loading_calendar(inputs)
	if (locale === "zh") return zh_rental_loading_calendar(inputs)
	if (locale === "ar") return ar_rental_loading_calendar(inputs)
	if (locale === "id") return id_rental_loading_calendar(inputs)
	if (locale === "it") return it_rental_loading_calendar(inputs)
	if (locale === "ru") return ru_rental_loading_calendar(inputs)
	if (locale === "pt") return pt_rental_loading_calendar(inputs)
	return ko_rental_loading_calendar(inputs)
});